import get from 'lodash/get';

import type { SharedVolumeClaimBinding, SharedVolumeRecord } from './types';

/** 表单 volumes 字段规范化为数组 */
export function normalizeVolumeList(raw: unknown): SharedVolumeRecord[] {
  return Array.isArray(raw) ? raw : [];
}

export function getVolumeClaimName(volume: SharedVolumeRecord | undefined, binding: SharedVolumeClaimBinding): string | undefined {
  if (!volume) return undefined;
  if (binding === 'pvcName') {
    const claim = get(volume, 'source.persistentVolumeClaimName') || get(volume, 'source.claimName');
    return claim ? String(claim) : undefined;
  }
  const claim = get(volume, 'source.persistentVolumeClaimInfo.claimName') || get(volume, 'source.claimName');
  return claim ? String(claim) : undefined;
}

/** 是否已配置 PVC claim（用于提交裁剪空行） */
export function isConfiguredSharedVolume(volume: SharedVolumeRecord | undefined, binding: SharedVolumeClaimBinding): boolean {
  return Boolean(getVolumeClaimName(volume, binding)?.trim());
}

export function filterConfiguredSharedVolumes(
  volumes: SharedVolumeRecord[] | undefined,
  binding: SharedVolumeClaimBinding = 'pvcInfo',
): SharedVolumeRecord[] {
  return normalizeVolumeList(volumes).filter((volume) => isConfiguredSharedVolume(volume, binding));
}
